import { FC, useMemo } from 'react';

import { Text } from 'shared/components/Text';
import { IOrder } from 'shared/interfaces/order.interface';
import { IPatient } from 'shared/interfaces/patient.interface';

type TOrdersProps = {
  order: IOrder;
};

const Orders: FC<TOrdersProps> = ({ order }) => {
  const productVariationTitles = useMemo(() => {
    const filteredProducts = order?.productVariations.filter(
      (value, index, self) =>
        self.findIndex(
          (selfIndex) =>
            selfIndex.productVariation?.product?.id ===
            value.productVariation?.product?.id
        ) === index
    );

    const titles = filteredProducts.map(
      (pv) => pv?.productVariation?.product?.title
    );
    return titles.join(', ').replace(/,([^,]*)$/, ' and$1');
  }, [order]);

  return (
    <div>
      {!!order.productVariations.length && (
        <Text type="sf-body-emphasized">{productVariationTitles}</Text>
      )}
      <Text type="sf-body">
        Order Id:{' '}
        <Text type="sf-body-emphasized" component="span">
          {order?.orderNumber}
        </Text>
      </Text>
      {order?.externalIdentifier && (
        <Text type="sf-body">
          EID:{' '}
          <Text type="sf-body-emphasized" component="span">
            {order?.externalIdentifier}
          </Text>
        </Text>
      )}
    </div>
  );
};

type TPatientsProps = {
  patient: IPatient;
};

const Patients: FC<TPatientsProps> = ({ patient }) => {
  return (
    <div>
      <Text type="sf-body">
        Patient Name:{' '}
        <Text type="sf-body-emphasized" component="span">
          {patient?.firstName} {patient?.lastName}
        </Text>
      </Text>
    </div>
  );
};

export type TSearchData = {
  orders: IOrder[];
  patients: IPatient[];
};

export const createSearchOptions = (searchData: TSearchData) => {
  const loadedOptions = [
    {
      label: 'Patients',
      options: searchData?.patients?.map((patient: IPatient) => {
        return {
          value: patient.id,
          label: <Patients patient={patient} />,
          type: 'patient'
        };
      })
    },
    {
      label: 'Orders',
      options: searchData?.orders?.map((order: IOrder) => {
        return {
          value: order.id,
          label: <Orders order={order} />,
          type: 'order'
        };
      })
    }
  ];
  return loadedOptions;
};
